import { Button, Divider, Stack } from '@mui/material'

import { Fragment } from 'react'

import { useLandingZoneMigration } from '@features/hooks/LandingZones/migration'

import Dialog from '@components/Dialog'
import { useDialog } from '@components/Dialog/use'
import Alert from '@components/Alert'

export const Footer = () => {
    const { handleNext } = useLandingZoneMigration()
    const { config, open, close } = useDialog()

    const onConfirm = () => {
        close()
        handleNext()
    }

    return (
        <Fragment>
            <Divider />
            <Stack direction={'row'} alignItems={'center'} justifyContent={'end'} sx={{ p: 2 }}>
                <Button onClick={() => open('Validate migration')}>Validate migration</Button>
            </Stack>

            <Dialog config={config} handleClose={close} handleApply={onConfirm} applyLabel={'Validate'} cancelLabel={'Cancel'}>
                <Alert severity={'warning'} title={'Once the migration is validated, rollback is no longer possible.'} />
            </Dialog>
        </Fragment>
    )
}

export default Footer